import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { MenuItems as View } from '@views';
import { routes } from '@constants';
import {
  getMenuCategories, getMenuSubcategories, getMenuItems,
} from '@helpers/menuItems';

const MenuItems = () => {
  const {
    categories, subcategories, items, sizes,
  } = useSelector(state => state.menu);

  const history = useHistory();
  const location = useLocation();

  const selectedCategoryId = location.state ? location.state.selectedCategoryId : null;

  useEffect(() => {
    if (!location.state) {
      history.goBack();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedCategoryId]);

  const handleMenuItemSelect = id => () => {
    history.push({
      pathname: `${routes.menuItems}/${id}`,
      state: {
        selectedCategoryId,
      },
    });
  };

  const handleMenuItemAdd = () => {
    history.push({
      pathname: routes.itemEdit,
      state: {
        categoryId: selectedCategoryId,
      },
    });
  };

  const handleBackUp = () => {
    history.push(routes.menu);
  };

  const memoizedCategories = useMemo(() => (
    getMenuCategories(categories)
  ), [selectedCategoryId]);

  const memoizedSubcategories = useMemo(() => (
    getMenuSubcategories(subcategories, categories, selectedCategoryId)
  ), [selectedCategoryId]);

  const memoizedItems = useMemo(() => (
    getMenuItems(categories, selectedCategoryId, items, sizes)
  ), [selectedCategoryId]);

  return (
    <View
      onMenuItemAdd={handleMenuItemAdd}
      categories={memoizedCategories}
      subcategories={memoizedSubcategories}
      selectedCategoryId={selectedCategoryId}
      menuItems={memoizedItems}
      onMenuItemSelect={handleMenuItemSelect}
      onBackUp={handleBackUp}
    />
  );
};

export default MenuItems;
